import { Component } from '@angular/core';
import { IonicPage, NavController, ToastController,ModalController, AlertController, LoadingController} from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { User } from '../../providers/user';
import { UserData } from '../../models/user';

@IonicPage({
  name: 'login',
  segment: 'login',
  priority: 'high'
})
@Component({
  selector: 'page-login',
  templateUrl: 'login.html'
})
export class LoginPage {
  // The account fields for the login form.
  // If you're using the username field with or without email, make
  // sure to add it to the type
  responseData : any;
  userData: UserData;
  credentials: { username: string, password: string } = {
    username: '',
    password: ''
  };

  // Our translated text strings
  private loginErrorString: string;
  private signupErrorString: string;

  constructor(public navCtrl: NavController,
    public user: User,
    public toastCtrl: ToastController,
    public translateService: TranslateService,
    public modalCtrl: ModalController,
    public loading: LoadingController,
    public alertCtrl: AlertController) {
    this.translateService.get('SIGNUP_ERROR').subscribe((value) => {
      this.signupErrorString = value;
    })
    this.translateService.get('LOGIN_ERROR').subscribe((value) => {
      this.loginErrorString = value;
    })
  }

  ionViewDidLoad() {
    if(localStorage.getItem('userId') && localStorage.getItem('password')){
      this.navCtrl.push('home');
    }
  }

  doSignup() {
    this.navCtrl.push('register');
  //   let modal = this.modalCtrl.create('signup');
  //   modal.onDidDismiss(item => {
  //     if (item) {
  //       this.user.signup(item).subscribe((resp) => {
  //         this.credentials.username = item.email;
  //         this.credentials.password = item.password;
  //         this.doLogin();
  //   }, (err) => {
  //     // Unable to sign up
  //     let toast = this.toastCtrl.create({
  //       message: this.signupErrorString,
  //       duration: 3000,
  //       position: 'top'
  //     });
  //     toast.present();
  //   });
  // }
  //   })
  //   modal.present();
  }


  // Attempt to login in through our User service
  doLogin() {
    let loading = this.loading.create({ spinner: 'hide', content: `<img width="200px" src="assets/images/Loading.gif" />`, duration: 5000, cssClass: 'activity-detail-loading2', showBackdrop: true, dismissOnPageChange: true });
    loading.present()
    if (this.credentials.username && this.credentials.password) {
      this.user.login(this.credentials).then((result) => {
        this.responseData = result;
        if (this.responseData.meta.status='ok') {
          if (this.responseData.data.user.two_auth === '1') {
            this.user.resendVerification('', this.credentials.username, this.credentials.password).subscribe((resp) => {
              loading.dismiss()
              this.navCtrl.push('verify', { userData: JSON.stringify(this.responseData.data.user), userId: this.credentials.username, password: this.credentials.password });
              },
                err => {
                  // Log errors if any
                  console.log(err);
                  this.presentToast("Something went wrong, please contact our support team for assistance");
                  loading.dismiss()
                });
          } else {
            localStorage.setItem('userData', JSON.stringify(this.responseData.data.user));
            localStorage.setItem('userId', this.credentials.username);
            localStorage.setItem('password', this.credentials.password);
            this.navCtrl.push('home');
            this.user.getPractices().subscribe(res => {
              if(res){
                localStorage.setItem('practiceData', JSON.stringify(res));
              }
            },
              err => {
                // Log errors if any
                console.log(err);
              });

          }
        }
        else {
          this.presentToast(this.loginErrorString);
        }
      }, (err) => {
        this.presentToast(this.loginErrorString);
      });
    }
    else {
      this.presentToast("Give username and password");
    }
  }

  forgotPassword(){
    let prompt = this.alertCtrl.create({
      title: 'Forgot Password?',
      message: "Please enter your email to reset your password",
      inputs: [
        {
          name: 'email',
          placeholder: 'email@xyz.com'
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
            // console.log('Cancel clicked');
          }
        },
        {
          text: 'Send',
          handler: data => { 
            let email:any;
            email = {email:data.email};
            this.user.forgotPassword(email).subscribe((resp) => {
            this.presentToast("Your password has been sent to your email address");
          }, (err) => {
            this.presentToast("The email id doesn't exist");
          })
          
          }
        }
      ]
    });
    prompt.present();
  }

  presentToast(msg) {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    });
    toast.present();
  }

  openAdminPortal(){
    window.open("https://growingminds-api.novopsych.com/admin/login", "_blank");
  }

  
}




// WEBPACK FOOTER //
// ./src/pages/login/login.ts